module.exports = __webpack_public_path__ + "img/1455652485.3892429b.jpg";